module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-active-49328614.png";